export enum EMemberTeams {
    Procurement_Team = 'MHPRC',
    Sales_Team = 'MHSAL',
    Logistics_Team = 'MHLOG',
    Accounting_Team = 'MHACT',
    Buyer_Custom_Role = 'BUCUS'
}
